/**
 * Detailed Summary page heading — STATIC by design. Scoping lives entirely
 * in the demand-category checkbox row (selectedDemandCategories); the heading
 * and URL carry no network scope (spec detail-summary-scoping R1.2).
 */

import React from 'react';
import Header from '@amzn/awsui-components-core/header';

export const PageHeader: React.FC = () => {
  return (
    <Header variant="h1" description="Weekly business review metrics">
      FAI - WBR Detailed Summary
    </Header>
  );
};
